import React from "react";
import { useLibraryUpliftsQuery } from "../../../graphql/query";
import { FIND_ALL_LIBRARY_UPLIFTS } from "../../../graphql/query";
import { DataImportTable } from "../data-import-table";
import { VpdDataImportType } from "../../../graphql/__generated_types__/globalTypes";
import { FileFormat } from "../data-import-form";

export const UpliftsDataImport = () => {
  const { loading, data } = useLibraryUpliftsQuery({
    onError: (error) => {
      console.error(error); // TODO: Error handling
    },
  });
  const libraryUplifts = data?.findAllLibraryUplifts || [];

  return (
    <DataImportTable
      accept={[FileFormat.XLSX]}
      columns={[
        {
          title: "Reason",
          dataIndex: "reason",
          key: "reason",
        },
        {
          title: "Group",
          dataIndex: "group",
          key: "group",
        },
      ]}
      loading={loading}
      items={libraryUplifts}
      importType={VpdDataImportType.Client}
      fetchQuery={FIND_ALL_LIBRARY_UPLIFTS}
      labels={{
        importButtonLabel: "Import Assumptions",
        emptyText: "No assumptions imported yet.",
        loadingText: "Loading assumptions...",
      }}
    />
  );
};
